
import React from 'react';

export const RecommendTools: React.FC = () => {
    return (
        <>
    <div style={{ marginTop: "5rem" }} className=" section-title section-title-blue" data-sal="slide-up">
        <h6>TOOLS WE USE & HIGHLY RECOMMEND</h6>
      </div>

    <section className="my-4 guide section-bg" >
      <div className="container">
        <div className="row">
          <div className="col-lg-4 video-box">
            <img src="RecommendTools/Canva_Logo.png" width='70%' className="img-fluid" alt="Canva Tool For Designing" />
          </div>
          <div className="col-lg-8 d-flex flex-column justify-content-center p-5">
            <div className="icon-box">
              <div className="icon"><i className="fas fa-pen-nib"></i></div>
              <h4 className="title"><a href="https://www.canva.com/en_in/pricing/">Designing Tool</a></h4>
              <p className="description">Easily create beautiful designs + documents. Use Canva's highly customizable drag-and-drop feature and professional layouts to design consistently stunning graphics for your business</p>
            </div>
          </div>
        </div>
      </div>
    </section>


    <section className="my-4 guide section-bg" >
      <div className="container">

        <div className="row">
          <div className="col-lg-8 d-flex flex-column justify-content-center p-5">
            <div className="icon-box">
              <div className="icon"><i className="fas fa-envelope"></i></div>
              <h4 className="title"><a href="https://convertkit.com/">E-mail Marketing Platform</a></h4>
              <p className="description">If you are rid of managing E-mail Campaigns & want to be able to easily send segments of your email list through automated campaigns (funnels or launch sequences), then Convertkit is perfect for you.</p>
            </div>
          </div>
          <div className="col-lg-4 video-box">
            <img  src="RecommendTools/ConvertKit.png" width='70%' className="img-fluid" alt="ConvertKit for E-mail Campaigns" />
          </div>
        </div>
      </div>
    </section>

    <section className="my-4 guide section-bg" >
      <div className="container">
        <div className="row">
          <div className="col-lg-4 video-box">
            <img src="RecommendTools/Siteground.png" width='70%' className="img-fluid" alt="Siteground for Hosting" />
          </div>
          <div className="col-lg-8 d-flex flex-column justify-content-center p-5">
            <div className="icon-box">
              <div className="icon"><i className="fas fa-server"></i></div>
              <h4 className="title"><a href="https://www.siteground.com/">Hosting Services</a></h4>
              <p className="description">Among all of the popular hosting options, my Professional Preference is Siteground, because of their fast servers(which really improve my site's SEO and performance) & helpful customer support.</p>
            </div>
          </div>
        </div>
      </div>
    </section>


        </>

    );
};
